var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.Utilities = OCS.Classes.Utilities || {};
OCS.Functions = OCS.Functions || {};
// Requires OCS.Classes.Utilities.base
OCS.Functions.define_calculations_utilities = function () {
    return new Class({
        Implements: [new Class(OCS.Interfaces.Utilities.base), new Class(OCS.Interfaces.Utilities.array), new Class(OCS.Interfaces.Utilities.calculations)]
    });
};
OCS.Classes.Utilities.calculations = OCS.Functions.define_calculations_utilities();